module.exports = __webpack_public_path__ + "static/media/how-to-use-pobble-video-thumb.de810945.jpg";